import React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';

export interface Props {
  confirmAction: () => void;
  isOpen: boolean;
  onClose: (openState: false) => void;
  isDisabled: boolean;
  selectedItemCount: number;
}

const useDialogTitle = (selectedItemCount: number) =>
  React.useMemo(() => {
    if (selectedItemCount > 1) {
      return translate('Delete {0} Items Forever?').format(selectedItemCount);
    } else {
      return translate('Delete Forever?');
    }
  }, [selectedItemCount]);

const useDialogContents = (selectedItemCount: number) =>
  React.useMemo(() => {
    if (selectedItemCount > 1) {
      return translate(
        'Are you sure you want to permanently delete the selected items and their contents?'
      );
    }
    return translate(
      'Are you sure you want to permanently delete the selected item and its contents?'
    );
  }, [selectedItemCount]);

export function PurgeDialog({
  confirmAction,
  isOpen,
  onClose,
  isDisabled,
  selectedItemCount,
}: Props) {
  const title = useDialogTitle(selectedItemCount);
  return (
    <DialogConfirmation
      id="confirm-purge-quiz-folder"
      open={isOpen}
      onClose={onClose}
      closeLabel={translate('Close')}
      title={title}
      actions={[
        <UIButton key="cancel" isDisabled={isDisabled} onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <UIButton
          key="primary"
          isDisabled={isDisabled}
          appearance="risky"
          onClick={confirmAction}
        >
          {translate('Delete Forever')}
        </UIButton>,
      ]}
    >
      <span className="text-blue-900">
        {useDialogContents(selectedItemCount)}
      </span>
    </DialogConfirmation>
  );
}
